import React from "react";

function RiddlerPrompt() {
  return <span className="prompt riddlerPrompt">{"<?>"}</span>;
}

export default RiddlerPrompt;
